import { useQuery } from '@tanstack/react-query';

import { listQueryOptions } from '@/lib/query-client';
import { makeQueryKeys } from '@/lib/query-keys';

import { engagementResourcesService } from '../services';
import type { ResourceListParams } from '../types';

export const engagementResourcesKeys = makeQueryKeys('engagement-resources');

export function useEngagementResources(params: ResourceListParams = {}) {
  return useQuery({
    queryKey: engagementResourcesKeys.list(params),
    queryFn: () => engagementResourcesService.list(params),
    ...listQueryOptions,
  });
}
